module.exports = __webpack_public_path__ + "img/p-plane.bc90fafd.png";